import React, { useState } from "react";
import styles from "./styles.module.scss";
import IItem from "../../../interfaces/IItem";
import { LabelFont, PageTitleFont } from "../../fonts";

export interface IDefaultMenuProps {
  className?: string;
  title?: string;
  items: Array<IItem>;
  onItemClick?: (item: IItem) => void;
  onSelectedChanged?: (items: Array<IItem>) => void;
  isMulti?: boolean;
  focusIndex?: number;
  stateless?: boolean;
}

const enterKey = 13;

export const Menu = ({
  title,
  items,
  onItemClick,
  onSelectedChanged,
  className,
  focusIndex,
  isMulti,
  stateless = false
}: IDefaultMenuProps) => {
  const [selected, setSelected] = useState<Array<IItem>>([]);

  function handleItemClick(item: IItem) {
    let newSelection: Array<IItem>;
    if (isMulti) {
      const clickedItem = items.find(i => i.value === item.value) as IItem;
      if (isSelected(clickedItem)) {
        newSelection = selected.filter(i => i.value !== item.value);
      } else newSelection = [...selected, clickedItem];
    } else newSelection = [item];
    onSelectedChanged && onSelectedChanged(newSelection);
    onItemClick && onItemClick(item);
    !stateless && setSelected(newSelection);
  }
  function isSelected(item: IItem) {
    return selected.find(i => i.value === item.value);
  }
  function handleKeyDown(event: KeyboardEvent, item: IItem) {
    debugger;
    if (event.keyCode === enterKey || event.charCode === enterKey)
      handleItemClick(item);
  }

  return (
    <div className={`${styles.root} ${className}`}>
      {title && (
        <div className={styles.title}>
          <PageTitleFont>{title}</PageTitleFont>
        </div>
      )}
      {items.map((item: IItem, index: number) => (
        <div
          key={index}
          onKeyPress={(e: any) => handleKeyDown(e, item)}
          onKeyDown={(e: any) => handleKeyDown(e, item)}
        >
          <div
            className={`${styles.item} ${isSelected(item) &&
              styles.selected} ${focusIndex === index && styles.focusIndex}`}
            onClick={() => handleItemClick(item)}
            key={item.value}
          >
            <LabelFont>{item.label}</LabelFont>
          </div>
        </div>
      ))}
    </div>
  );
};
